module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"feedback":"Have feedback on the book?"},"ar":{"feedback":"هل لديك ملاحظات حول الكتاب؟"}}')
  delete Component.options._Ctor
}
